module.exports = __webpack_public_path__ + "static/img/03.44a0935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour2/03.jpg
// module id = /I6r
// module chunks = 0